import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles(theme => ({
  buttonTextWhite: {
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: fade(
        theme.palette.primary.contrastText,
        theme.palette.action.hoverOpacity
      ),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
}))

export default function StyledCardButton (props) {
  const classes = useStyles()

  return (
    <Button
      size='small'
      className={classes.buttonTextWhite}
      onClick={props.onClick}
    >
      {props.buttonTitle}
    </Button>
  )
}
